import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { UserContextProvider } from "./context/UserContext";
import { AdminDataContextProvider } from "./context/SessionContext";

const root = ReactDOM.createRoot(document.getElementById("core"));

root.render(
  <BrowserRouter>
    <AdminDataContextProvider>
      <UserContextProvider>
        <App />
      </UserContextProvider>
    </AdminDataContextProvider>
  </BrowserRouter>
);
